<select class="form-control" [(ngModel)]="weekday" (ngModelChange)="emitValue()">
  <option [ngValue]="0">Sunday</option>
  <option [ngValue]="1">Monday</option>
  <option [ngValue]="2">Tuesday</option>
  <option [ngValue]="3">Wednesday</option>
  <option [ngValue]="4">Thursday</option>
  <option [ngValue]="5">Friday</option>
  <option [ngValue]="6">Saturday</option>
</select>